import { render, staticRenderFns } from "./Detail-Service.vue?vue&type=template&id=5af3aff9"
import script from "./Detail-Service.vue?vue&type=script&lang=js"
export * from "./Detail-Service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports